const LOCALE = {
    // Additions and services
    TRYING_ON: "Үйде қарап көру",
    NOTIFY_ORDER_DELIVERY: "CDEK-те тапсырыс жасау туралы хабарлама",
    PART_DELIV: "Ішінара жеткізу",
    COURIER_PACKAGE_A2: "Курьерлік пакет А2",
    BUBBLE_WRAP: "Ауа-көпіршікті пленка",
    ENVELOPE_A4_CDEK_FREE: "Қағаз конверт",
    GET_UP: "Қабатқа көтеру",
    LOADING_OPERATIONS_AT_THE_SENDER: "Жөнелтушіде ТЖЖ",
    LOAD_THE_OPERATION_AT_THE_RECIPIENT: "Алушыда ТЖЖ",
    BOX: "Қорап",
    CARTON_BOX_XS: "Қорап XS",
    CARTON_BOX_S: "Қорап S 2КГ",
    CARTON_BOX_S_2_KILOS: "Қорап S 2КГ",
    CARTON_BOX_M : "Қорап М",
    CARTON_BOX_L_12_KILOS: "Қорап L 12КГ",
    CARTON_BOX_1KG: "Қорап 1КГ",
    CARTON_BOX_2KG: "Қорап 2КГ",
    CARTON_BOX_3KG: "Қорап 3КГ",
    CARTON_BOX_5KG: "Қорап 5КГ",
    CARTON_BOX_10KG : "Қорап 10КГ",
    CARTON_BOX_20KG : "Қорап 20КГ",
    CARTON_BOX_30KG : "Қорап 30КГ",
    CARTON_BOXES: "Қораптар",
    GET_UP_FLOOR_BY_HAND: "Қабатқа көтеру",
    GET_UP_FLOOR_BY_ELEVATOR: "Қабатқа көтеру",
    CARTON_BOX_XS_INFO: "Қорап XS (17x12x9) 0.5КГ",
    CARTON_BOX_S_2_KILOS_INFO: "Қорап S (23x19x10) 2КГ",
    CARTON_BOX_M_INFO : "Қорап M (33x25x15) 5КГ",
    CARTON_BOX_L_12_KILOS_INFO: "Қорап L (31x25x38) 12КГ",
    CARTON_BOX_1KG_INFO: "Қорап (24x17x10) 1КГ",
    CARTON_BOX_2KG_INFO: "Қорап (34x24x10) 2КГ",
    CARTON_BOX_3KG_INFO: "Қорап (24x24x21) 3КГ",
    CARTON_BOX_5KG_INFO: "Қорап (40x24x21) 5КГ",
    CARTON_BOX_10KG_INFO : "Қорап (40x35x28) 10КГ",
    CARTON_BOX_20KG_INFO : "Қорап (47x40x43) 20КГ",
    CARTON_BOX_30KG_INFO : "Қорап (69x39x42) 30КГ",
    HEAVY_GOOD: "Ауыр жүк",
    LATHING: 'Орау',

    // Common fields
    address: "Мекенжай",
    tg_id: "Telegram ID",
    max_id: "Max ID",
    from_location: "Қайдан",
    to_location: "Қайда",
    total_size: "Сәлем өлшемі",
    total_weight: "Сәлем салмағы",
    calculate_weight: "Көлемдік салмақ",
    cityFrom: "Жөнелту қаласы",
    cityTo: "Тағайындау қаласы",
    deliveryType: "Жеткізу түрі",
    deliveryMode: "Жеткізу режимі",
    deliveryPeriod: "Жеткізу мерзімі",
    delivery_sum: "Жеткізу құны",
    calculation_parameters: "Есептеу параметрлері",

    fio: "ТАӘ",
    contract_face: "Байланыс тұлғасы",
    number: "Телефон номері",
    additional: "Қосымша номер",
    pvz: "ПВЗ",

    insurance: "Тауар бірлігіне сақтандыру",
    weight: "Тауар салмағы",
    vat: "ҚҚС мөлшері",
    vat_sum: "ҚҚС сомасы",

    // Step 1 - Invoice Main
    main_section: "Негізгі",
    payment_on_receipt_label: "Алушыдан төлем алу",
    yes: "Иә",
    no: "Жоқ",
    no_vat: "ҚҚС жоқ",
    sender: "Жөнелтуші",
    receiver: "Алушы",
    third_party: "Үшінші тұлға",
    contract_number: "Шарт нөмірі",
    select_contract_number: "Шарт нөмірін таңдаңыз",
    template: "Үлгі",
    template_name: "Үлгі атауы",
    template_name_exists: "Осындай атаудағы үлгі бұрыннан бар",
    no_template: "Үлгісіз",
    who_are_you: "Сіз кімсіз",
    city_from: "Жөнелту қаласы",
    city_to: "Тағайындау қаласы",
    search_city: "Қала іздеу",
    popular_cities: "Танымал қалалар",

    // Step 2 - Tariff Panel
    tariff_selection: "Тариф таңдау",
    sort_by: "Сұрыптау",
    price: "Баға",
    period: "Мерзім",
    filter: "Сүзгі",
    no_tariffs_available: "Қол жетімді тариф жоқ",
    working_days: "жұмыс күні",
    from: "бастап",
    to: "дейін",
    tariff_not_selected: "Тариф таңдалмады",
    error: "Қате",
    error_loading_tariffs: "Тарифтерді жүктеу қатесі",

    // Step 3 - Additions
    additional_services_cost: "Қосымша қызметтер құны",
    floor: "Қабат",
    has_elevator: "Лифт бар",
    free: "Тегін",
    manager_will_inform_price: "Менеджер бағасын хабарлайды",
    total: "Барлығы",

    // Step 4 - Delivery
    phones: "Телефондар",
    field_required: "Өріс міндетті",
    name_cannot_be_only_digits: "Атау тек сандардан тұра алмайды",
    pvz_selection_factors: "ПВЗ таңдауға келесі параметрлер әсер етуі мүмкін:",
    goods_weight: "Тауар салмағы",
    volumetric_weight_used: "(көлемдік салмақ қолданылады)",
    receiving_city: "Алу қаласы",
    not_selected: "таңдалмаған",
    payment_on_receipt_yes: "Алу кезінде төлем: иә",
    trying_on_needed_yes: "Қарап көру қажеттілігі: иә",
    no_suitable_pvz: "Қолайлы ПВЗ жоқ",
    nothing_found: "Ештеңе табылмады",
    contact_person_required: "Байланыс тұлғасы*",
    pickup_address_required: "Сәлем алу мекенжайы*",
    pvz_delivery_address_required: "ПВЗ жеткізу мекенжайы*",
    delivery_address_required: "Жеткізу мекенжайы*",
    pickup_date_required: "Сәлем алу күні*",
    arrive_from_required: "Келу басы*",
    arrive_to_required: "Келу соңы*",
    break_from: "Үзіліс басы",
    break_to: "Үзіліс соңы",
    phone_number_required: "Телефон номері*",
    additional_number: "Қосымша номер",

    // Step 5 - Calculation
    payment_from_receiver: "Алушыдан төлем",
    payment_from_receiver_hint: "Тек алу кезінде төлем болса ғана есептеледі",
    payment_by_contract: "Шарт бойынша төлем",
    payment_by_contract_hint: "Шарт бойынша алынатын төлем",
    additional_collection_from_receiver: "Алушыдан қосымша алым",
    additional_collection_hint: "Тек алу кезінде төлем болса ғана есептеледі.",
    insurance_per_unit: "Тауар бірлігіне сақтандыру",
    additional_charge_cod: "Алушыдан қосымша алым (жинақталған төлем)",

    // Step 6 - Result Panel
    calculation_params: "Есептеу параметрлері",
    additional_services: "Қосымша қызметтер",
    sender_info: "Жөнелтуші",
    receiver_info: "Алушы",
    need_barcode: "Штрих-код қажет",
    total_from_client: "Клиенттен барлығы",
    total_by_contract: "Шарт бойынша барлығы",
    no_additional_services: "Қосымша қызметтер жоқ",
    no_information: "Ақпарат жоқ",
    not_specified: "Көрсетілмеген",
    door: "Есік",
    warehouse: "Қойма",
    floor_word: "қабат",
    without_elevator: "лифтсіз",
    with_elevator: "лифтпен",
    place_word: "Орын",

    // Places Panel
    default_goods_name: "ТТҚ",
    personal_items: "Жеке заттар",
    place_number: "Орын #",
    calculated_weight_kg: "Есептелген салмақ, (кг):",
    height_cm: "Биіктігі, см",
    length_cm: "Ұзындығы, см",
    width_cm: "Ені, см",
    weight_kg: "Салмақ, кг",
    attachment_description: "Салынған заттың сипаттамасы",
    insurance_per_item: "Тауар бірлігіне сақтандыру",
    quantity: "Саны",
    delete_place: "Орынды жою",
    goods: "Тауарлар",
    no_name: "Атаусыз",
    pcs: "дана",
    article: "Мақала",
    goods_name: "Тауар атауы",
    payment_per_item: "Тауар бірлігіне төлем",
    vat_sum_label: "ҚҚС сомасы",
    delete_goods: "Тауарды жою",
    add_place: "Орын қосу",

    // Steps Header
    new_invoice: "Жаңа жүкқұжат",
    step_main_data: "Негізгі деректер",
    step_tariffs: "Тарифтер",
    step_additional_services: "Қосымша қызметтер",
    step_receiver_sender: "Алушы/жөнелтуші",
    step_calculation: "Есептеу",
    step_total: "Барлығы",

    // City Selection
    city_from_placeholder: "Қайдан",
    city_to_placeholder: "Қайда",

    // Validation Messages
    not_all_required_fields_filled: "Барлық міндетті өрістер толтырылмаған",
    insurance_sum_limit: "Сақтандыру сомасы 399999р аспауы керек",

    // Common
    loading: "Жүктелуде",
    save: "Сақтау",
    cancel: "Болдырмау",
    create: "Жасау",
    update: "Жаңарту",
    delete: "Жою",
    edit: "Өңдеу",
    back: "Артқа",
    next: "Келесі",
    select: "Таңдау",
    search: "Іздеу",
    apply: "Қолдану",
    reset: "Тазалау",

    // Auth
    authorization: "Авторизация",
    identifier: "Идентификатор",
    password: "Құпия сөз",
    contract_number_label: "Шарт нөмірі",
    select_language: "Тілді таңдаңыз",
    language: "Тіл",
    russian: "Русский",
    english: "Английский",
    kazakh: "Қазақша",
    agree_terms: "Мен пайдалану шарттарымен келісемін",
    login: "Кіру",
    how_to_auth: "Ассистентке қалай кіруге болады?",
    contact_information: "Байланыс ақпараты",
    first_name: "Аты",
    last_name: "Тегі",
    middle_name: "Әкесінің аты (болса)",
    phone: "Телефон",
    not_all_fields_filled: "Барлық міндетті өрістер толтырылмаған",
    contract_not_found: "Бұл шарт табылмады",
    contract_different_keys: "Бұл шарт үшін басқа интеграция кілттері қолданылады",
    integration_keys_error: "Интеграция кілттерінде қате",

    // First Time Modal
    creating_invoice: "Жүкқұжатты жасау",
    calculating_cost: "Құнды есептеу",
    creating_template: "Үлгіні жасау",
    editing_template: "Үлгіні өңдеу",
    creating_claim: "Талап қою жасау",
    tracking_cargo: "Жүкті қадағалау",
    auth_login: "Авторизация",
    auth_contact: "Авторизация",
    instruction: "Нұсқаулық",
    watch_short_instruction: "Пайдалану бойынша қысқа нұсқаулықты қараңыз",
    video_instruction: "Бейне нұсқаулық",
    not_opening_fullscreen: "Толық экранға ашылмай ма?",
    open_in_new_tab: "Жаңа қойындыда ашу",
    close: "Жабу",
    browser_not_support_video: "Браузеріңіз бейнені қолдамайды.",
    understood: "Түсінікті",
    skip: "Өткізу",
    dont_show_again: "Енді көрсетпеу",

    // Delivery Types
    from_door: "есіктен",
    to_door: "есікке дейін",
    from_warehouse: "қоймадан",
    to_warehouse: "қоймаға дейін",

    // Calculation Panel
    calculation: "Есептеу",
    commission_from_receiver: "Алушыдан комиссия",
    delivery_from_receiver: "Алушыдан жеткізу",
    
    // Units
    pcs_short: "дана",
    kg_short: "кг",
    art_short: "арт",
    without_vat: "ҚҚС жоқ",

    // Templates list
    templates_list_title: "Үлгілер",
    templates_loading: "Жүктелуде...",
    templates_error: "Үлгілерді жүктеу мүмкін болмады",
    templates_empty: "Сақталған үлгілер жоқ",
    notifications_title: "Хабарламалар",
    notifications_empty: "Хабарламалар жоқ",
    notifications_load_more: "Тағы жүктеу",
    notifications_loading: "Жүктелуде...",
    notifications_files: "Файлдар",
    notifications_file_download: "Жүктеу",
    templates_create: "Үлгі жасау",
    templates_delete: "Жою",
    templates_delete_confirm: "Үлгіні жойыңыз ба?",
    templates_delete_confirm_title: "Жоюды растау",
    templates_delete_warning: "Әрекетті қайтару мүмкін емес. Үлгі қалпына келтірілмей жойылады.",
    templates_delete_confirm_btn: "Жою",
    templates_delete_error: "Үлгіні жою мүмкін болмады",
    templates_delete_success: "Үлгі сәтті жойылды",
    templates_contract_number: "Келісімшарт нөмірі",
    templates_created_at: "Жасалған күні",
    templates_template_no_name: "Үлгі №",
    templates_role: "Сіздің рөліңіз",
    who_pay_sender: "Жіберуші",
    who_pay_reciver: "Алушы",
    who_pay_another: "Үшінші тұлға",
    templates_from_address: "Жөнелту мекенжайы",
    templates_to_address: "Алу мекенжайы",

    // Contracts list
    contracts_list_title: "Келісімшарттар тізімі",
    contracts_loading: "Жүктелуде...",
    contracts_error: "Келісімшарттарды жүктеу мүмкін болмады",
    contracts_empty: "Келісімшарттар табылмады",
    contracts_contract_number: "Келісімшарт нөмірі",
    contracts_client_company_name: "Компания атауы",
    contracts_disable: "Өшіру",
    contracts_disable_confirm_title: "Өшіруді растау",
    contracts_disable_warning: "{{contract_number}} келісімшарты өшіріледі. Әрекетті қайтару мүмкін емес.",
    contracts_disable_confirm_btn: "Өшіру",
    contracts_disable_success: "Келісімшарт сәтті өшірілді",
    contracts_disable_error: "Келісімшартты өшіру мүмкін болмады",

    // Employees
    employees_list_title: "Қызметкерлер",
    employees_empty: "Қызметкерлер табылмады",
    employees_contracts_error: "Келісімшарттарды жүктеу мүмкін болмады",
    employees_load_error: "Қызметкерлерді жүктеу мүмкін болмады",
    employees_delete: "Қызметкерді өшіру",
    employees_delete_confirm_title: "Қызметкерді өшіру",
    employees_delete_confirm_body: "{{name}} қызметкерін өшіру керек пе? Әрекетті қайтару мүмкін емес.",
    employees_delete_confirm_btn: "Өшіру",
    employees_delete_success: "Қызметкер сәтті өшірілді",
    employees_delete_error: "Қызметкерді өшіру мүмкін болмады",
    employees_delete_no_tg_id: "Қызметкер идентификаторы жоқ",
    employees_invite_button: "Қызметкерді шақыру",
    employees_invite_title: "Қызметкерді шақыру",
    employees_invite_get_link: "Сілтемені алу",
    employees_invite_copy_link: "Сілтемені көшіру",
    employees_invite_link_copied: "Сілтеме көшірілді",
    employees_invite_error: "Сілтемені алу мүмкін болмады",

    // Home & Navigation
    home_title: "Басты бет",
    nav_home: "Басты бет",
    nav_menu_title: "Мәзір",
    nav_menu_open: "Мәзірді ашу",
    nav_menu_close: "Мәзірді жабу",
    nav_invoice: "Жүкқұжат жасау",
    nav_templates: "Үлгілер",
    nav_create_template: "Үлгі жасау",
    nav_contracts: "Келісімшарттар",
    nav_add_contract: "Келісімшарт қосу",
    nav_employees: "Қызметкерлер",
    nav_calculation: "Жеткізу есебі",
    nav_claim: "Претензия",
    nav_tracking: "Қабарландыру",
    nav_tracking_by_number: "Нөмір бойынша қабарландыру",
    nav_tracking_from_bot: "Боттан қабарландыру",
    nav_feedback: "Кері байланыс",
    nav_chat: "Чат",
    nav_instructions: "Нұсқаулар",
    install_app_button: "Қосымшаны орнату",
    install_page_title: "СДЭК Көмекші",
    install_page_subtitle: "Жылдам кіру үшін қосымшаны жұмыс үстеліне қосыңыз",
    install_page_feature_1: "Жүкқұжаттарды жылдам жасау",
    install_page_feature_2: "Жөнелтілімдерді қадағалау",
    install_page_feature_3: "Мәртебелер туралы push-хабарландырулар",
    install_page_feature_4: "Telegram-сыз жұмыс істейді",
    install_page_button: "Жұмыс үстеліне орнату",
    install_page_ios_title: "iPhone / iPad-қа орнату",
    install_page_ios_steps_title: "Safari-да қосымшаны негізгі экранға қосыңыз:",
    install_page_ios_two_w1a: "Белгішені басыңыз",
    install_page_ios_two_home: "«Негізгі экранға қосу»",
    install_page_ios_two_w2a: "Басыңыз",
    install_page_ios_two_w2b: "«Бөлісу»",
    install_page_ios_hint: "«Бөлісу» түймесі төменде көрінбесе, екінші тәсілді қолданыңыз.",
    install_page_success: "Қосымша орнатылды!",
    install_page_success_subtitle: "Енді оны жұмыс үстелінен аша аласыз",
    install_page_go_home: "Басты бетке өту",
    nav_profile: "Профиль",
    nav_profile_edit: "Профильді өңдеу",
    profile_title: "Профиль",
    profile_name: "Аты",
    profile_username: "Пайдаланушы аты",
    profile_contract: "Келісімшарт нөмірі",
    profile_no_contracts: "Байланыстырылған келісімшарттар жоқ",
    profile_error: "Профильді жүктеу мүмкін болмады",
    profile_edit: "Өңдеу",
    profile_update_title: "Профильді өңдеу",
    profile_update_success: "Профиль сәтті жаңартылды",
    profile_update_error: "Профильді жаңарту мүмкін болмады",
    instructions_list_title: "Бейне нұсқаулар",
    instructions_video_invoice: "Жүкқұжат жасау",
    instructions_video_templates: "Үлгілер",
    instructions_video_calculation: "Құн есебі",
    instructions_video_claims: "Претензиялар",
    instructions_video_tracking: "Қабарландыру",
    instructions_video_contracts: "Келісімшарттар",
    instructions_video_employees: "Қызметкерлер",
    instructions_video_chat: "Менеджермен чат",

    share_button: "Бөлісу",
    share_copied: "Көшірілді",
    share_failed: "Көшіру мүмкін болмады",

    // EAEU Warning Modal
    attention: "Назар аударыңыз!",
    eaeu_warning_text: "Тапсырысқа қосымша құжаттар қосу және қосымша мәліметтер беру қажет, егер сізге жеңілдетілген жасау қажет болса, онда тапсырыс жасауға оралыңыз және «Артикул», «Тауар атауы» және «Сіз кімсіз» өрістеріндегі деректерді өзгертпеңіз",

    // Calculate Invoice
    calculate_invoice_title: "Жүкқұжатты есептеу",

    // Tracking
    tracking_parcel_title: "Сәлемді бақылау",

    // Claim
    new_claim_title: "Жаңа талап",
    claim_word: "Талап",
    your_email: "Сіздің email",
    contact_person_fio: "Байланыс тұлғасының ТАӘ",
    required_sum_rub: "Талап етілетін сома",
    describe_situation: "Жағдайды сипаттаңыз",
    attach_files: "Файлдарды тіркеу",
    invoice_number_label: "Жүкқұжат нөмірі",
    select_invoice: "Жүкқұжатты таңдаңыз",
    incorrect_email: "Қате email",
    attach_photo_video: "Тауардың фотосын немесе бейнесін тіркеңіз",
    file_exceeds_size: "Файл 200MB-тан асады",
    invalid_file_type: "Файл түрі жарамсыз",

    // Chat with Manager
    chat_with_manager_title: "Менеджермен чат",
    select_contract_for_chat: "Чатқа кіру үшін шартты таңдаңыз",
    enter_button: "Кіру",
    chat_with_manager: "Менеджермен чат",

    // Package Tracking
    track_number_input: "Трек нөмірі",
    enter_track_number: "Трек нөмірін енгізіңіз",
    invalid_contract: "Жарамсыз шарт",
    invalid_track_number: "Жарамсыз трек нөмір",
    find_button: "Табу",
    package_not_found: "Бұл нөмір бойынша сәлем табылмады",
    employee_word: "Қызметкер",

    // Track Item
    track_number_prefix: "Трек №",
    contract_word: "Шарт",
    sending_progress: "Жіберілуде...",
    barcode_button: "Штрих-код",
    current_location: "Ағымдағы орналасуы",
    planned_delivery_date: "Жоспарланған жеткізу күні",

    // EAEU Manager Modal
    additional_information_title: "Қосымша ақпарат",
    eaeu_manager_modal_text: "Тапсырысқа кеден бақылауы мен СНТ үшін құжаттар қосу қажет болса, сондай-ақ жүкқұжатта: жүк жөнелтушіні, жүк жөнелтуші мекенжайын, нақты сатушыны, нақты сатушы мекенжайын, қабылдау-тапсыру актісінің немесе ТТН нөмірін қосу, тауар атауын ағылшын тілінде, маркировка кодын немесе адал белгіні, материалды, өндіру елін немесе тауарға сілтемені көрсету қажет болса, менеджерге хабарласыңыз",

    // Instructions
    instruction_not_found: "Нұсқаулық табылмады",
    specify_video_url: "Бейне URL-ін key параметрінде көрсетіңіз.",
    invalid_url: "Жарамсыз URL",
    key_must_contain_url: "Key параметрі жарамды бейне URL-ін қамтуы керек.",
    browser_not_support_video_tag: "Браузеріңіз бейне тегін қолдамайды.",

    // First Time Modal Descriptions
    desc_create_invoice: "Жүк жіберу үшін жүкқұжатты қалай тез жасауға болатынын біліңіз",
    desc_calculate_cost: "Жүкті жеткізу құнын есептеуді үйреніңіз",
    desc_create_template: "Жүкқұжаттарды тез жасау үшін үлгі жасаңыз",
    desc_edit_template: "Бар үлгіні қалай өзгертуге болатынын біліңіз",
    desc_create_claim: "Жеткізу бойынша талаптар жасауды үйреніңіз",
    desc_tracking: "Жүктің мәртебесін қалай бақылауға болатынын біліңіз",
    desc_auth: "Ассистентке қалай кіруге болатынын біліңіз",
    desc_auth_contact: "Авторизация процесін аяқтау",

    // Step 4 - Delivery Panel
    fio_required: "ТАӘ*",
    fio_or_company_required: "ТАӘ немесе компания атауы*",
    delivery_word: "Жеткізу",

    // Tracking Options
    select_tracking_option: "Бақылау нұсқасын таңдаңыз",
    by_package_number: "Сәлем нөмірі бойынша",
    invoice_created: "Жүкқұжат жасалды",
    invoice_created_in_assistant: "Ассистентте жасалған жүкқұжат",

    // Bot Rating
    assistant_rating_title: "Ассистентті бағалау",
    rating_label: "Рейтинг",
    select_rating: "Бағаны таңдаңыз",
    comment_placeholder: "Түсініктеме",
    fill_required_field: "Міндетті өрісті толтырыңыз",
    submit_rating: "Бағаны жіберу",
    thanks_for_review: "Пікіріңіз үшін рахмет!",
    ok_button: "Жақсы",

    // Auth Contact
    contact_phone: "Байланыс телефоны",
    need_help: "Көмек керек пе?",
    video_instruction_link: "Бейне нұсқаулық",
    accept_button: "Қабылдау",
    fill_all_required_fields: "Барлық міндетті өрістерді толтырыңыз.",
    data_sent_successfully: "Деректер сәтті жіберілді!",

    // City Search
    select_contract_for_city_search: "Қала іздеу үшін шартты таңдаңыз",

    // Voice Input
    voice_panel_title: "Өрістерді дауыспен толтыру",
    voice_from_to: "Қайдан және қайда",
    voice_place_and_goods_params: "Орын мен тауар параметрлері",
    voice_tariffs: "Тарифтер",
    voice_additional_services: "Қосымша қызметтер",
    voice_receiver: "Алушы",
    voice_sender: "Жөнелтуші",
    voice_cargo_weight: "Жүк салмағы",
    voice_invoice_number: "Жүкқұжат нөмірі",
    voice_problem_description: "Мәселе сипаттамасы",
    voice_damage_amount: "Залал сомасы",
    voice_contact_details: "Байланыс деректері",
    voice_additional_info: "Қосымша ақпарат",
    voice_analyzing: "Деректерді талдаудамыз...",
    voice_record_hold: "Жазу үшін түймені басып тұрыңыз",
    voice_record_release: "Өңдеуді бастау үшін түймені жіберіңіз",
    voice_allow_access: "Қатынауға рұқсат ету",
    
    // Navigation
    go_to_menu: "Басты мәзірге",
}

export default LOCALE

